import React, {useEffect, useMemo, useState} from "react";
import {Alert, Button, Col, Modal, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import {
    fetchAdvancedTypes,
    fetchBankAccounts,
    fetchCashRegisters,
    fetchPOS,
    fetchSalesGeneralSettings,
    fetchClients,
    putClient,
    fetchProductsONChange,
} from "../../../../_apis/api";
import EditableTable from "../../../primer/Editable-Table";
import QuickEdit from "../../../primer/QuickEdit";
import {useDispatch, useSelector} from "react-redux";
import {
    filterNaNValue,
    getCurrentUser,
    getDefaultOptionByValue,
    getDOYOptions,
    getGreekCurrencyFormat,
    getInstallationsTypes,
    getModeByInstallation,
    getNumberByInstallation,
    getOptionsByData,
    getPreNumberByInstallation,
    getSelectedInstallation,
    getSelectedPreNumbers,
    getVatCategoryOptions,
    isEmpty,
    removeDuplicateObjects,
} from "../../../../_helpers/commonFunctions";
import {setSaveQuotations} from "../../../../_reducers/activitySlice";
import {
    fixDocumentTaxesDisplay,
    getLabelByValue,
    getObjectFromArrayOfObjects
} from "../../../../_helpers/helperFunctions";
import {
    newQuotationInitialValue,
    setCorrelatedVisitData,
    setNewQuotationClientCustomData,
    setNewQuotations,
    setNewQuotationNewProduct,
    setQuotationDiscountObject
} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import TextArea from "../../../common/TextArea";
import {preNumberGreek} from "../../../../_data/settings/advanced-types-search";
import {toast} from "react-toastify";
import axios from "axios";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import NewClientModal from "../Clients/new-client-modal";
import {
    getDiscountExclusiveVat,
    getNetValue,
    getNetValueByTotalValue,
    getPriceExclusiveVat,
    getProductFee,
    getProductOtherTax,
    getProductStamp,
    getProductWithholdTax, getSalesTaxesData,
    getSalesTotals,
    getTaxes,
    getTotalValue,
    getUnitPrice,
    getVatPercent,
    getVatValue,
    parseNumber
} from "../../../../_helpers/product-sales-calculations";
import {vatCategoryData} from "../../../../_data/mydata/vatCategory";
import BetterCheckBox from "../../../common/BetterCheckBox";
import moment from "moment";
import HourPicker from "../../../primer/HourPicker";
import "./salesnew.css";
import getMyData from "../../../../_helpers/sharedmydata";
import {useTranslation} from "../../../../hooks/useTranslation";

const apiURL2 = process.env.REACT_APP_API_URL2;

const QuotationsNew = () => {
    const {t} = useTranslation();
    let date = new Date();
    const currentTime = date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0');
    const dispatch = useDispatch();
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const PRODUCTS_DATA = useSelector((state) => state.PRODUCTS_DATA);
    const SALES = useSelector((state) => state.SALES);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const SALES_SETTINGS = useSelector((state) => state.SALES_SETTINGS);
    const newQuotationClientCustomData = useSelector((state) => state.SALES.newQuotationClientCustomData);
    const clientVatCategory = newQuotationClientCustomData.clientVatCategory;
    const clientVatReason = newQuotationClientCustomData.clientVatReason;
    const clientCustomVat = newQuotationClientCustomData.clientCustomVat;
    const correlatedVisitData = useSelector((state) => state.SALES.correlatedVisitData);

    const requestData = {
        company: company.id
    }
    const requestData3 = {
        company: company.id,
        year: String(company.year),
    }
    const currentUser = getCurrentUser();
    const requestData2 = {
        company: company.id,
        year: String(company.year),
        isActive: "active",
        userId: currentUser.id
    }
    let requestDataF = {
        company: company.id,
        year: String(company.year),
        name: ''
    };
    // Options for Document Type Dropdown
    const allDocumentTypes = SETTINGS.settings.advancedTypes;
    const measurementUnitOptions= getMyData({type: 'mu', settings: SETTINGS});
    const clientPaymentsDT = getObjectFromArrayOfObjects(
        allDocumentTypes,
        "Quotations",
        "section"
    );
    const documentTypesOptions = getOptionsByData(
        clientPaymentsDT,
        "_id",
        "name"
    );
    const productCodeColumns = [
        {
            label: t('SalesNew.productCodeTable.code'),
            name: "code",
        },
        {
            label: t('SalesNew.productCodeTable.alternativeCode'),
            name: "alternateCode",
        },
        {
            label: t('SalesNew.productCodeTable.productName'),
            name: "name",
        },
        {
            label: t('SalesNew.productCodeTable.alternativeName'),
            name: "alternateName",
        },
    ];
    const clientDropdownColumns = [
        {
            label: t('SalesNew.clientTable.code'),
            name: "systemCode",
        },
        {
            label: t('SalesNew.clientTable.name'),
            name: "name",
        },
        {
            label: t('SalesNew.clientTable.phone'),
            name: "phone",
        },
        {
            label: t('SalesNew.clientTable.email'),
            name: "email",
        },
        {
            label: t('SalesNew.clientTable.vatNumber'),
            name: "vatNumber",
        },
    ];
    const clientInstallationsDropdownColumns = [
        {
            label: t('SalesNew.installationTable.type'),
            name: "type",
        },
        {
            label: t('SalesNew.installationTable.address'),
            name: "address",
        }
    ];

    const [refreshPage, setRefreshPage] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const [showCategoryConfirmation, setshowCategoryConfirmation] = useState(false);
    const [tempCatValue, setTempCatValue] = useState({});
    const [showProductTableSpinner, setProductTableSpinner] = useState('false');
    const [quotationsProductList, setQuotationsProductList] = useState(PRODUCTS_DATA.products.slice());
    const [clientsListData, setClientsListData] = useState(CLIENTS_DATA.clients.slice());
    const [clientInstallationListData, setClientInstallationListData] = useState(CLIENTS_DATA.installations.slice());
    const [showDiscountModal, setShowDiscountModal] = useState(false);

    useEffect(() => {
        dispatch(fetchAdvancedTypes(requestData));
        dispatch(fetchSalesGeneralSettings(requestData2));
        dispatch(fetchPOS(requestData2));
        dispatch(fetchBankAccounts(requestData2));
        dispatch(fetchCashRegisters(requestData2));
        dispatch(fetchClients(requestData3, setClientsListData));
        dispatch(fetchProductsONChange(requestData3, setQuotationsProductList));
    }, []);

    useEffect(() => {
        // Update number after save and repeat
        if (SETTINGS.settings.advancedTypes && SALES.newQuotations.numberingMode !== 'manual') {
            const findDoc = SETTINGS.settings.advancedTypes.find((el) => el._id === SALES.newQuotations.documentType);
            if (findDoc) {
                const findDocNumbering = findDoc.documentNumbering.find((el) => el.installationMasterId === SALES.newQuotations.installation && String(SALES.newQuotations.preNumber) === String(el.preNumber))
                if (findDocNumbering) {
                    if (Number(findDocNumbering.number) + 1 !== Number(SALES.newQuotations.number)) {
                        dispatch(setNewQuotations({...SALES.newQuotations, number: findDocNumbering.number + 1}));
                    }
                }
            }
        }
    }, [SETTINGS.settings.advancedTypes])

    useEffect(() => {
        if (SALES.newQuotations.documentType !== "") {
            if(SALES.newQuotations.installation !== undefined && SALES.newQuotations.installation !== ''){
                let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, SALES.newQuotations.installation);
                setPreNumberGreekOptions(newPreNumbers);
            }
        }
    },[])
    //useEffect for loading sale template
    useEffect(() => {
        if (SALES.newQuotations.documentType !== "") {
            if(SALES.newQuotations.installation !== undefined && SALES.newQuotations.installation !== '') {
                let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, SALES.newQuotations.installation);
                setPreNumberGreekOptions(newPreNumbers);
                let newQuotationsData = {};
                let selectedInstallation = getObjectFromArrayOfObjects(selectedDocumentTypeData['documentNumbering'], SALES.newQuotations.installation, "installationMasterId");
                let selectedInstallationNumbering = selectedInstallation.filter(selected => selected.preNumber === SALES.newQuotations.preNumber);
                if (Object.keys(selectedInstallation).length > 0 && selectedInstallationNumbering.length > 0 && selectedInstallationNumbering[0].numberingMode !== "manual") {
                    newQuotationsData.number = selectedInstallationNumbering[0].number + 1;
                } else {
                    newQuotationsData.number = "";
                }
                dispatch(setNewQuotations({ ...SALES.newQuotations, ...newQuotationsData }));
            }
        }
    },[SALES.newQuotations.installation, SALES.newQuotations.preNumber])

    const processCorrelatedDataSequence = async () => {
        let currentQuotationsState = newQuotationInitialValue;
        currentQuotationsState = await handleOnChange({value: correlatedVisitData.documentType, label: correlatedVisitData.documentTypeName}, 'dd', 'documentType', currentQuotationsState);
        currentQuotationsState = await handleOnChange({value: null, row: {_id: correlatedVisitData.client}}, 'acdd', 'client', currentQuotationsState);
        currentQuotationsState = await handleOnChange({value: correlatedVisitData.paymentType, label: correlatedVisitData.paymentTypeName}, 'dd', 'paymentType', currentQuotationsState);
        let prodIdx = 1;
        if (correlatedVisitData?.autoSaleProduct) { // Visits
            currentQuotationsState = await quotationsProductListActions.insert({key: ""}, {field: "productId", value: correlatedVisitData?.autoSaleProduct}, currentQuotationsState);
            currentQuotationsState = await quotationsProductListActions.update({unitPrice: 10}, prodIdx, null, null, currentQuotationsState);
            currentQuotationsState = await quotationsProductListActions.update({quantity: correlatedVisitData?.autoSaleProductQuantity || 1}, prodIdx, null, null, currentQuotationsState);
            prodIdx++;
        }
        if (correlatedVisitData?.referralArray?.length > 0) {
            for (const row of correlatedVisitData?.referralArray) {
                currentQuotationsState = await quotationsProductListActions.insert({key: ""}, {field: "productId", value: row.product}, currentQuotationsState);
                currentQuotationsState.products.forEach((prod) => {
                    prod.quickEdit = true;
                })
                const prepUpdate = {};
                prepUpdate.unitPrice = +row.amount || 0;
                if (row.barcode === "MONTHLY_EOPYY_INVOICE") {
                    prepUpdate.showAlternativeNameOnPrint = "true";
                    prepUpdate.alternativeName = row.alternativeName;
                }
                currentQuotationsState = await quotationsProductListActions.update(prepUpdate, prodIdx, null, null, currentQuotationsState);
                currentQuotationsState = await quotationsProductListActions.update({quantity: +row.quantity || 1}, prodIdx, null, null, currentQuotationsState);
                if (row.discount) currentQuotationsState = await quotationsProductListActions.update({discount: +row.discount}, prodIdx, null, null, currentQuotationsState);
                prodIdx++;
            }
        }
        if (correlatedVisitData.notes) currentQuotationsState.notes += `\n${correlatedVisitData.notes}`;
        dispatch(setNewQuotations(currentQuotationsState));
        dispatch(setCorrelatedVisitData({}));
    }

    useEffect(() => {
        if (!isEmpty(correlatedVisitData?.documentType) && !isEmpty(correlatedVisitData?.client)) {
            processCorrelatedDataSequence();
        }
    }, [correlatedVisitData])

    let ptTypes = SALES_SETTINGS.salesGeneralSettings.paymentTypes;
    const paymentTypeOptions = getOptionsByData(ptTypes, "_id", "name");
    const [preNumberGreekOptions, setPreNumberGreekOptions] = useState([]);
    let selectedDocumentTypeData = [];
    let dtInstallationsOptions = [];
    let disabledFields = false;
    if (SALES.newQuotations.documentType === undefined || SALES.newQuotations.documentType === '') {
        disabledFields = true;
    } else {
        let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, SALES.newQuotations.documentType, '_id');
        if (dtData.length > 0) {
            selectedDocumentTypeData = dtData['0'];
            dtInstallationsOptions = getOptionsByData(selectedDocumentTypeData['documentNumbering'], "installationMasterId", "installation");
            dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
        }
    }

    const clientProductsColumns = [
        {
            name: "No",
            field: "no",
            width: "40px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNew.productTable.code.code'),
            field: "code",
            width: "120px",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: quotationsProductList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t('SalesNew.productTable.code.placeholder')
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t('SalesNew.productTable.name.name'),
            field: "name",
            width: "400px",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: quotationsProductList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t('SalesNew.productTable.name.placeholder')
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t('SalesNew.productTable.quantity'),
            field: "quantity",
            width: "90px",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'accounting',
                config: {
                    maxLength: 10 // Given in the wireframe
                }
            }
        },
        {
            name: t('SalesNew.productTable.mu'),
            field: "muLabel",
            editable: false,
            width: "60px",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNew.productTable.unitPrice'),
            field: "unitPrice",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            width: "130px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    decimalLimit: 3,
                    maxLength: 10,
                }
            }
        },
        {
            name: t('SalesNew.productTable.discount'),
            field: "discount",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            width: "80px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: "%",
            field: "isPerDiscount",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'radio',
                name: 'discountType',
                radioLogic: 'oneperrow',
                options: [{
                    value: true,
                    label: 'True'
                }, {
                    value: false,
                    label: 'False'
                }]
            }
        },
        {
            name: "€",
            field: "isDiscountAmount",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'radio',
                radioLogic: 'oneperrow',
                name: 'discountType',
                options: [{
                    value: true,
                    label: 'True'
                }, {
                    value: false,
                    label: 'False'
                }]
            }
        },
        {
            name: t('SalesNew.productTable.vat'),
            field: "vatPercentage",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNew.productTable.netValue'),
            field: "netValue",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            width: "150px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNew.productTable.taxes'),
            field: "taxes",
            editable: false,
            width: "90px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNew.productTable.totalValue'),
            field: "totalValue",
            editable: true,
            width: "150px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
    ]

    const handleConfirmCategory = async () => {
        // Populate Selected Category Data
        let newQuotationsData = {};
        let value = tempCatValue.new;
        newQuotationsData.documentType = value;
        newQuotationsData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
        newQuotationsData.corelatedDocument = "";
        newQuotationsData.corelatedDocumentName = "";
        newQuotationsData.correlatedDclObj = "";
        newQuotationsData.correlatedDclName = "";
        const selectedDocumentTypeData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, value, "_id");
        if (selectedDocumentTypeData.length > 0) {
            let selectedDTData = selectedDocumentTypeData['0'];
            newQuotationsData.fuelInvoice = selectedDTData?.fuelInvoice === "active" ? "active" : "inactive";
            if (selectedDTData?.reverseDeliveryNotePurpose) newQuotationsData.reverseDeliveryNotePurpose = selectedDTData.reverseDeliveryNotePurpose;
            newQuotationsData.isDeliveryNote = selectedDTData?.isDeliveryNote === "active";
            if (selectedDTData?.vatPaymentSuspension === "active") {
                newQuotationsData.vatPaymentSuspension = true;
            } else {
                newQuotationsData.vatPaymentSuspension = undefined;
            }
            setActiveTab(0);
            newQuotationsData.paymentType = "";
            newQuotationsData.paymentTypeName = "";
            newQuotationsData.bankAccount = "";
            newQuotationsData.bankAccountName = "";
            let selectedInstallation = getSelectedInstallation(selectedDTData['documentNumbering']);
            // This applies only if selected check box is tick in the table.
            if (Object.keys(selectedInstallation).length > 0) {
                newQuotationsData.installation = selectedInstallation.installationMasterId;
                newQuotationsData.preNumber = selectedInstallation.preNumber;
                newQuotationsData.installationMode = selectedInstallation.numberingMode;
                newQuotationsData.numberingMode = selectedInstallation.numberingMode;
                newQuotationsData.number = selectedInstallation.number + 1;
            } else if(dtInstallationsOptions.length === 1){
                newQuotationsData.installation = dtInstallationsOptions[0].value;
                newQuotationsData.preNumber = "";
                newQuotationsData.number = "";
                newQuotationsData.installationMode = "";
                newQuotationsData.numberingMode = "";
            } else {
                newQuotationsData.installation = "";
                newQuotationsData.preNumber = "";
                newQuotationsData.number = "";
                newQuotationsData.installationMode = "";
                newQuotationsData.numberingMode = "";
            }
            // This will pre number given in document number table
            let newPreNumbers = getSelectedPreNumbers(selectedDTData['documentNumbering'], preNumberGreek, selectedInstallation.installationMasterId);
            setPreNumberGreekOptions(newPreNumbers);
            // Preposed Sales Purpose from the advanced types page
            newQuotationsData.salePurpose = selectedDTData.proposedSalePurpose;
            newQuotationsData.specialInvoiceCategory = selectedDTData?.specialInvoiceCategory ? selectedDTData.specialInvoiceCategory : "";
            // Clear Product List on change
            newQuotationsData.products = [];
            //Clear Client
            newQuotationsData.client = "";
            newQuotationsData.clientName = "";
            newQuotationsData.clientCode = "";
            newQuotationsData.address = "";
            newQuotationsData.vat = "";
            newQuotationsData.doy = "";
            newQuotationsData.city = "";
            newQuotationsData.amka = "";
            newQuotationsData.clientCategoryName = "";
            newQuotationsData.clientCategory = "";
            newQuotationsData.country = "";
            newQuotationsData.pc = "";
            newQuotationsData.email = "";
            newQuotationsData.phone = "";
            newQuotationsData.activity = "";
            newQuotationsData.vatCategory = "";
            setClientInstallationListData(CLIENTS_DATA.installations.slice());
            newQuotationsData.clientInstallationType = "";
            newQuotationsData.clientInstallationId = "";
            // Set Client Vat Category used for product vat calculation
            dispatch(setNewQuotationClientCustomData({
                clientVatCategory: "Normal VAT",
                clientVatReason: "",
                clientCustomVat: 0,
            }))
        }
        dispatch(setNewQuotations({ ...SALES.newQuotations, ...newQuotationsData }));
        setshowCategoryConfirmation(false);
    }

    const onChangeSearch = (keyword, setData) => {
        requestDataF.name = keyword
        if(keyword.length >= 2) {
            dispatch(fetchClients(requestDataF, setData))
        }
    }

    const handleOnChange = async (e, type = "default", ddname = '', currentQuotationsState = null) => {
        if (!ACTIVITY.saveQuotations) dispatch(setSaveQuotations(true));

        let name;
        let value = '';
        if (type === 'dd' || type === 'ac') {
            value = e.value;
            name = ddname;
        } else if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (type === 'acdd') {
            e = e.row;
            value = e._id;
            name = ddname;
        } else if (type === 'tp') {
            value = e;
            name = ddname;
        } else if (type === "checkbox") {
            value = e.target.checked;
            name = ddname;
        } else if (type === "bettercheckbox") {
            value = e.target.checked ? "active" : "inactive";
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }

        let quotationsData = Object.assign({}, currentQuotationsState ? currentQuotationsState : SALES.newQuotations);
        let newQuotationsData = {};

        if (name === 'documentType' && quotationsData.documentType !== value) {
            if (!isEmpty(SALES_SETTINGS?.salesGeneralSettings?.proposedSaleNotes)) {
                newQuotationsData["notes"] = SALES_SETTINGS.salesGeneralSettings.proposedSaleNotes;
            }
            if (quotationsData.documentType !== "") {
                quotationsData.corelatedDocument = "";
                quotationsData.corelatedDocumentName = "";
                quotationsData.correlatedDclObj = "";
                quotationsData.correlatedDclName = "";
                // Show confirmation before category change.
                setshowCategoryConfirmation(true);
                setTempCatValue({ e: e, new: value, old: quotationsData.documentType });
            } else {
                // Populate Selected Category Data
                newQuotationsData[name] = value;
                let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, value, '_id');
                if (dtData.length > 0) {
                    dtInstallationsOptions = getOptionsByData(dtData['0']['documentNumbering'], "installationMasterId", "installation");
                    dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
                }
                newQuotationsData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
                const selectedDocumentTypeData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, value, "_id");
                if (selectedDocumentTypeData.length > 0) {
                    let selectedDTData = selectedDocumentTypeData['0'];
                    newQuotationsData.fuelInvoice = selectedDTData?.fuelInvoice === "active" ? "active" : "inactive";
                    if (selectedDTData?.reverseDeliveryNotePurpose) newQuotationsData.reverseDeliveryNotePurpose = selectedDTData.reverseDeliveryNotePurpose
                    newQuotationsData.isDeliveryNote = selectedDTData?.isDeliveryNote === "active";
                    if (selectedDTData?.vatPaymentSuspension === "active") {
                        newQuotationsData.vatPaymentSuspension = true;
                    } else {
                        newQuotationsData.vatPaymentSuspension = undefined;
                    }
                    setActiveTab(0);
                    let selectedInstallation = getSelectedInstallation(selectedDTData['documentNumbering']);
                    if (Object.keys(selectedInstallation).length > 0) {
                        newQuotationsData.installation = selectedInstallation.installationMasterId;
                        newQuotationsData.preNumber = selectedInstallation.preNumber;
                        newQuotationsData.installationMode = selectedInstallation.numberingMode;
                        newQuotationsData.numberingMode = selectedInstallation.numberingMode;
                        if(newQuotationsData.numberingMode !== "manual") {
                            newQuotationsData.number = selectedInstallation.number + 1;
                        }
                    } else if(dtInstallationsOptions.length === 1){
                        newQuotationsData.installation = dtInstallationsOptions[0].value;
                        newQuotationsData.preNumber = "";
                        newQuotationsData.number = "";
                        newQuotationsData.installationMode = "";
                        newQuotationsData.numberingMode = "";
                    } else {
                        newQuotationsData.installation = "";
                        newQuotationsData.preNumber = "";
                        newQuotationsData.number = "";
                        newQuotationsData.installationMode = "";
                        newQuotationsData.numberingMode = "";
                    }

                    // This will pre number given in document number table
                    let newPreNumbers = getSelectedPreNumbers(selectedDTData['documentNumbering'], preNumberGreek, newQuotationsData.installation);
                    setPreNumberGreekOptions(newPreNumbers);
                    // Preposed Sales Purpose from the advanced types page
                    newQuotationsData.salePurpose = selectedDTData.proposedSalePurpose;
                    newQuotationsData.specialInvoiceCategory = selectedDTData?.specialInvoiceCategory ? selectedDTData.specialInvoiceCategory : "";
                }
            }
        } else {
            newQuotationsData[name] = value;
        }

        if (name === 'client') {
            // populating client values on the sales form
            // Same code is used with quick edit client to repopulate the data after change. Starts from line number 933.
            let selectedClient = getObjectFromArrayOfObjects(clientsListData, value, '_id');
            // Get Client Data from the API.
            await axios.get(apiURL2 + `/client/get-client-id-by/${value}`)
                .then((res) => {
                    if (res.data && res.data.status === "200") {
                        selectedClient['0'] = res.data.data;
                    }
                }).catch((err) => {
                    console.log(err);
                })
            if (selectedClient.length > 0) {
                let sClient = selectedClient['0'];
                newQuotationsData.clientName = sClient.name;
                newQuotationsData.clientCode = !isEmpty(sClient.manualCode) ? sClient.manualCode : sClient.systemCode; // It is the client code
                newQuotationsData.address = sClient.address;
                newQuotationsData.vat = sClient.vatNumber;
                newQuotationsData.doy = getLabelByValue(getDOYOptions(), Number(sClient.DOY), 'value');
                newQuotationsData.city = sClient.city;
                newQuotationsData.amka = sClient?.amka;
                newQuotationsData.clientCategoryName = sClient?.categoryName;
                newQuotationsData.clientCategory = sClient?.category;
                newQuotationsData.country = sClient.country;
                newQuotationsData.pc = sClient.postalCode;
                newQuotationsData.email = sClient.email;
                newQuotationsData.phone = sClient.phone;
                newQuotationsData.activity = sClient.activity;
                newQuotationsData.vatCategory = sClient.vatCategory;
                sClient.installations.map(installation => {
                    installation.type = getLabelByValue(getInstallationsTypes(), installation.type, 'value');
                    return installation;
                })
                setClientInstallationListData(sClient.installations);
                newQuotationsData.clientInstallationType = sClient.installations[0]?.type;
                newQuotationsData.clientInstallationId = sClient.installations[0]?.no;
                // Set Client Vat Category used for product vat calculation
                dispatch(setNewQuotationClientCustomData({
                    clientVatCategory: sClient?.vatCategory ? sClient.vatCategory : "Normal VAT",
                    clientVatReason: sClient?.vatReason ? sClient.vatReason : "",
                    clientCustomVat: !isEmpty(sClient?.customVat) ? sClient.customVat : 0,
                }))
            }
            //reset correlated DCl
            if(!isEmpty(quotationsData.correlatedDclObj) && (newQuotationsData?.client !== quotationsData?.client)) {
                newQuotationsData.correlatedDclObj = "";
                newQuotationsData.correlatedDclName = "";
            }
        }

        if(name === 'clientInstallation'){
            let selectedClientInstallation = "";
            clientInstallationListData.map(installation => {
                if(value === installation._id){
                    selectedClientInstallation = installation;
                }
                return installation;
            })
            if(selectedClientInstallation !== ""){
                newQuotationsData.clientInstallationType = selectedClientInstallation.type;
                newQuotationsData.clientInstallationId = selectedClientInstallation.no;
                newQuotationsData.address = selectedClientInstallation.address;
                newQuotationsData.doy = getLabelByValue(getDOYOptions(), Number(selectedClientInstallation.DOY), 'value');
                newQuotationsData.city = selectedClientInstallation.city;
                newQuotationsData.pc = selectedClientInstallation.postalCode;
            }
        }

        if (name === 'paymentType') {
            newQuotationsData.paymentTypeName = getLabelByValue(paymentTypeOptions, value, 'value');

            // This will update the pre-selected POS / Bank
            let paymentTypesData = getObjectFromArrayOfObjects(SALES_SETTINGS.salesGeneralSettings.paymentTypes, value, '_id');
            if (paymentTypesData && paymentTypesData.length > 0) {
                let selectedPaymentType = paymentTypesData['0'];
                if (selectedPaymentType?.type === "pos") {
                    newQuotationsData.bankAccount = selectedPaymentType.options?.preSelectedPosBankAccount;
                }

                if (selectedPaymentType?.type === "bank-account" || selectedPaymentType?.type === "bank-account-outside" || selectedPaymentType?.type === "web-banking") {
                    newQuotationsData.bankAccount = selectedPaymentType.options?.preSelectedPosBankAccount;
                }

                if (selectedPaymentType?.type === "cash") {
                    newQuotationsData.bankAccount = "";
                }
            }
        }

        // Update Installation Field Values on Change
        if (name === 'installation') {
            newQuotationsData.installationName = getLabelByValue(dtInstallationsOptions, value, 'value');
            newQuotationsData.preNumber = getPreNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            newQuotationsData.installationMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            newQuotationsData.numberingMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            if(newQuotationsData.numberingMode !== "manual") {
                newQuotationsData.number = getNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId') + 1;
            }
            // This will pre number given in document number table
            let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, value);
            setPreNumberGreekOptions(newPreNumbers);
        }
        if (name === "salePurpose") {
            newQuotationsData['salePurposeName'] = "";
        }
        // It will update the last available number from the API.
        if ((name === 'documentType' || name === 'preNumber' || name === 'installation') &&
            (
                (quotationsData.documentType !== '' || newQuotationsData.documentType !== '') &&
                (quotationsData.preNumber !== '' || newQuotationsData.preNumber !== '') &&
                (quotationsData.installation !== '' || newQuotationsData.installation !== '')
            )) {
            let checkAtParams = {};
            checkAtParams.company = company.id;
            checkAtParams.id = !newQuotationsData.documentType ? quotationsData.documentType : newQuotationsData.documentType;
            checkAtParams.preNumber = !newQuotationsData.preNumber ? quotationsData.preNumber : newQuotationsData.preNumber;
            checkAtParams.installation = !newQuotationsData.installation ? String(quotationsData?.installation) : String(newQuotationsData?.installation);

            if (checkAtParams.id && checkAtParams.preNumber && checkAtParams.installation) {
                let returnData = null;
                await axios.post(apiURL2 + `/settings/add-setting-advance-type-check`, checkAtParams, { headers: { 'Content-Type': 'application/json' } })
                    .then(res => {
                        if (res.data && res.data.status === '200') {
                            if (res.data.number !== undefined) {
                                newQuotationsData.number = parseInt(res.data.number) + 1;
                            }
                        }
                        if(currentQuotationsState) {
                            returnData = { ...quotationsData, ...newQuotationsData };
                        } else {
                            dispatch(setNewQuotations({ ...quotationsData, ...newQuotationsData }));
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                if(returnData) return returnData;
            } else {
                if(currentQuotationsState) {
                    return { ...quotationsData, ...newQuotationsData };
                } else {
                    dispatch(setNewQuotations({ ...quotationsData, ...newQuotationsData }));
                }
            }
        } else {
            if(currentQuotationsState) {
                return { ...quotationsData, ...newQuotationsData };
            } else {
                dispatch(setNewQuotations({ ...quotationsData, ...newQuotationsData }));
            }
        }
    }

    const quickClientFields = [
        {
            name: t('SalesNew.quickClientTable.name'),
            field: "name",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.vatCategory'),
            field: "vatCategory",
            editable: true,
            inputType: {
                options: getVatCategoryOptions(),
                type: 'select',
            }
        },
        {
            name: t('SalesNew.quickClientTable.vatNumber'),
            field: "vatNumber",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: "ΑΜΚΑ Ασθενή",
            field: "amka",
            hidden: SALES.newQuotations?.clientCategoryName !== "Patient",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.phone'),
            field: "phone",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.email'),
            field: "email",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.address'),
            field: "address",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.city'),
            field: "city",
            editable: true,
            inputType: {
                type: "text",
            },
        },
    ];

    const [updateSaleAmounts, setUpdateSaleAmounts] = useState(false);

    const quotationsProductListActions = {
        insert: async (e, data, currentState = null) => {
            if (!ACTIVITY.saveQuotations) dispatch(setSaveQuotations(true));
            let currentQuotationsState = currentState ? currentState : SALES.newQuotations;

            let productData = null;
            // Get Product By Code
            if (data && data?.field === 'code') {
                await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(data.value)}`, {params: company})
                    .then(res => {
                        if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                            productData = res.data.data['0'];
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
            }
            // Get Product By Name
            if (data && data?.field === 'name') {
                await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-name/${encodeURIComponent(data.value)}`,{params :company})
                    .then(res => {
                        if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                            productData = res.data.data['0'];
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
            }
            // Get Product By _id (used in dcl)
            if (data && data?.field === 'productId') {
                await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-id/${encodeURIComponent(data.value)}`)
                    .then(res => {
                        if (res.data && res.data.data && res.data.status === '200') {
                            productData = res.data.data;
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
            }
            if (productData !== null && Object.keys(productData).length > 0) {
                if (e.key !== "Enter") {
                    setProductTableSpinner('true');
                    let tempNewProduct = Object.assign({}, SALES.newQuotationNewProduct);
                    // Get Current Product Details with the API if product and client are selected.
                    if (currentQuotationsState.client && currentQuotationsState.client !== '') {
                        await axios.post(`${process.env.REACT_APP_API_URL2}/category/get-product-code-by-price`, { _id: productData._id, client: currentQuotationsState.client, company: company.id })
                            .then((res) => {
                                if (res.data.status === "200") {
                                    let pldata = res.data?.data;
                                    productData.vatIncluded = pldata.vatIncluded;
                                    tempNewProduct.isPerDiscount = pldata.isPerDiscount;
                                    tempNewProduct.isDiscountAmount = pldata.isDiscountAmount;
                                    tempNewProduct.discount = pldata.discount;
                                    productData.price = pldata.productPrice;
                                    productData.unitPrice = filterNaNValue(pldata.productPrice);
                                }
                            }).catch((error) => {
                                setProductTableSpinner('false');
                                console.log(error);
                            })
                    }
                    if (currentQuotationsState.fuelInvoice === "active") {
                        tempNewProduct.fuelCode = productData.fuelCode;
                    }
                    if (productData?.invoiceDetailType) {
                        tempNewProduct.invoiceDetailType = productData.invoiceDetailType;
                    } else {
                        tempNewProduct.invoiceDetailType = undefined;
                    }
                    if (productData?.specialOption) {
                        tempNewProduct.specialOption = productData.specialOption;
                    }
                    if (productData?.notVAT195) {
                        tempNewProduct.notVAT195 = productData.notVAT195;
                    }
                    if (productData?.showAlternativeNameOnPrint === "true") {
                        tempNewProduct.showAlternativeNameOnPrint = "true";
                        tempNewProduct.alternativeName = productData.alternateName;
                    }
                    if (productData?.showAlternativeCodeOnPrint === "true") {
                        tempNewProduct.showAlternativeCodeOnPrint = "true";
                        tempNewProduct.alternativeCode = productData.alternateCode;
                    }
                    tempNewProduct.name = productData?.name;
                    tempNewProduct.code = productData?.code;
                    tempNewProduct.quantity = 1;
                    tempNewProduct.mu = productData?.measurementUnit;
                    tempNewProduct.muLabel = getLabelByValue(measurementUnitOptions, productData?.measurementUnit.toString(), 'value');
                    tempNewProduct.discount = 0;
                    tempNewProduct.taxes = 0;
                    if (!isEmpty(productData?.deductionsEuro) && parseFloat(productData?.deductionsEuro) > 0) {
                        tempNewProduct.deductionsEuro = Number(parseFloat(productData?.deductionsEuro).toFixed(2));
                    }
                    if (productData?.vatIncluded === "true") {
                        const price = parseFloat(productData.price);
                        const vat = isNaN(productData.vat) ? 0 : parseFloat(productData.vat);
                        if (vat > 0) {
                            tempNewProduct.unitPrice = Number(Number(price/(1 + vat/100)).toFixed(2));
                        } else {
                            tempNewProduct.unitPrice = parseNumber(productData.price);
                        }
                    } else {
                        tempNewProduct.unitPrice = parseNumber(productData.price); // Direct price from the product preferred price
                    }
                    tempNewProduct[data.field] = data.value; // Updates from table edit
                    if (data.field === 'isPerDiscount' && (data.value === "on" || data.value === "true")) {
                        tempNewProduct.isPerDiscount = "true";
                        tempNewProduct.isDiscountAmount = "false";
                    }
                    if (data.field === 'isDiscountAmount' && (data.value === "on" || data.value === "true")) {
                        tempNewProduct.isPerDiscount = "false";
                        tempNewProduct.isDiscountAmount = "true";
                    }
                    // Fix for loading calculation on insert
                    let discountType = 'euro';
                    if (tempNewProduct.isPerDiscount === 'true') {
                        discountType = 'per';
                    }
                    if(productData?.isTaxLine === "true"){
                        tempNewProduct.vatPercentage  = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                        if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                            tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(tempNewProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
                        } else if (clientVatCategory === "Zero VAT") {
                            tempNewProduct.vatId = "7";
                        } else {
                            tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                        }
                        tempNewProduct.vatReason      = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
                        tempNewProduct.unitPrice      = getPriceExclusiveVat(tempNewProduct.unitPrice, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded);
                        tempNewProduct.discount       = getDiscountExclusiveVat(tempNewProduct.discount, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded, discountType);
                        tempNewProduct.netValue       = 0;
                        tempNewProduct.withHoldTax    = productData.withholdTax;
                        tempNewProduct.otherTax       = productData.otherTaxes;
                        tempNewProduct.stamp          = productData.stamp;
                        tempNewProduct.fee           = productData.fee;
                        tempNewProduct._id            = productData._id;
                        tempNewProduct.isTaxLine      = productData.isTaxLine;
                        tempNewProduct.classificationCategory = '';
                        tempNewProduct.classificationType = '';
                        tempNewProduct.vatExpenseType = '';
                        tempNewProduct.isTaxLineWithoutVat      = productData.isTaxLineWithoutVat;
                        tempNewProduct.taxes          = getNetValue(tempNewProduct.unitPrice, tempNewProduct.quantity, tempNewProduct.discount, discountType);
                        tempNewProduct.otherTaxEuro   = getProductOtherTax(tempNewProduct, SETTINGS);
                        tempNewProduct.witholdTaxEuro = getProductWithholdTax(tempNewProduct, SETTINGS);
                        tempNewProduct.feeEuro        = getProductFee(tempNewProduct, SETTINGS);
                        tempNewProduct.stampEuro      = getProductStamp(tempNewProduct, SETTINGS);
                        tempNewProduct.vat            = getVatValue(tempNewProduct.taxes, tempNewProduct.vatPercentage);
                        tempNewProduct.totalValue     = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes);
                    } else {
                        tempNewProduct.vatPercentage = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                        if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                            tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(tempNewProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
                        } else if (clientVatCategory === "Zero VAT") {
                            tempNewProduct.vatId = "7";
                        } else {
                            tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                        }
                        tempNewProduct.vatReason = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
                        tempNewProduct.unitPrice = getPriceExclusiveVat(tempNewProduct.unitPrice, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded);
                        tempNewProduct.discount = getDiscountExclusiveVat(tempNewProduct.discount, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded, discountType);
                        tempNewProduct.netValue = getNetValue(tempNewProduct.unitPrice, tempNewProduct.quantity, tempNewProduct.discount, discountType);
                        tempNewProduct.withHoldTax = productData.withholdTax;
                        tempNewProduct.otherTax = productData.otherTaxes;
                        tempNewProduct.fee = productData.fee;
                        tempNewProduct.stamp = productData.stamp;
                        tempNewProduct._id = productData._id;
                        tempNewProduct.classificationCategory = '';
                        tempNewProduct.classificationType = '';
                        tempNewProduct.vatExpenseType = '';
                        tempNewProduct.taxes = getTaxes(tempNewProduct, SETTINGS);
                        tempNewProduct.otherTaxEuro = getProductOtherTax(tempNewProduct, SETTINGS);
                        tempNewProduct.witholdTaxEuro = getProductWithholdTax(tempNewProduct, SETTINGS);
                        tempNewProduct.feeEuro = getProductFee(tempNewProduct, SETTINGS);
                        tempNewProduct.stampEuro        = getProductStamp(tempNewProduct, SETTINGS);
                        if (productData.vatIncluded === "true") {
                            let price = isNaN(Number(productData.price)) ? 0 : productData.price;
                            tempNewProduct.vat = getVatValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, price);
                            tempNewProduct.totalValue = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes, tempNewProduct.vat);
                        } else {
                            tempNewProduct.vat = getVatValue(tempNewProduct.netValue, tempNewProduct.vatPercentage);
                            tempNewProduct.totalValue = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes);
                        }
                    }
                    // If validated fields done add new row
                    let oldSalesProducts = currentQuotationsState.products;
                    let updatePriceListNewProduct = Object.assign({}, tempNewProduct);
                    updatePriceListNewProduct.name = tempNewProduct.name;
                    updatePriceListNewProduct.code = tempNewProduct.code;
                    updatePriceListNewProduct.no = oldSalesProducts.length + 1;
                    updatePriceListNewProduct.id = oldSalesProducts.length + 1;
                    updatePriceListNewProduct._id = tempNewProduct._id
                    dispatch(setNewQuotationNewProduct(tempNewProduct)); // Update redux
                    let pPlroducts = [...oldSalesProducts, updatePriceListNewProduct];
                    let productTotals = getSalesTotals(pPlroducts, SETTINGS);
                    let productSalesTaxes = getSalesTaxesData(pPlroducts, currentQuotationsState.extraData, productTotals, SETTINGS);
                    let extraData = {...currentQuotationsState.extraData};
                    if(productSalesTaxes.length > 0){
                        productSalesTaxes.map((salesTax) => {
                            if(salesTax.vatPercentage === "Invoice Level Tax"){
                                extraData.witholdTaxEuro = salesTax.withholdTaxes;
                                extraData.otherTaxEuro = salesTax.otherTaxes;
                                extraData.feeEuro = salesTax.fees;
                                extraData.stampEuro = salesTax.stamp;
                            }
                            return salesTax;
                        })
                    }
                    let totalTaxes = 0;
                    let withHoldTaxes = 0;
                    let deductions = 0;
                    if(productSalesTaxes.length > 0 && productSalesTaxes[0].vatPercentage === "Invoice Level Tax"){
                        totalTaxes = parseFloat( (Number(productSalesTaxes[0].otherTaxes) + Number(productSalesTaxes[0].fees) + Number(productSalesTaxes[0].stamp)).toString());
                        withHoldTaxes = parseFloat(productSalesTaxes[0].withholdTaxes).toFixed(2);
                        deductions = parseFloat(productSalesTaxes[0].deductions).toFixed(2);
                    }
                    if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
                        productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
                        productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
                    }
                    dispatch(setNewQuotationNewProduct(SALES.newQuotationNewProductInitialValue)); // Reset new category mydata
                    if(!isEmpty(currentState)) {
                        setProductTableSpinner('false');
                        return { ...currentQuotationsState, products: pPlroducts, salesTaxes: productSalesTaxes, ...productTotals };
                    } else {
                        dispatch(setNewQuotations({ ...currentQuotationsState, products: pPlroducts, salesTaxes: productSalesTaxes, ...productTotals }));
                    }
                }
            }
            setProductTableSpinner('false');
        },
        update: async (data, id, rowIndex, e, currentState = null) => {
            // Set if editing the form
            if (!ACTIVITY.saveQuotations) dispatch(setSaveQuotations(true));

            // Set Loading true
            setProductTableSpinner('true');
            let quickEdit = false;
            let foundProduct;
            let productData = null;
            let currentQuotationsState = currentState ? currentState : SALES.newQuotations;
            let plProducts = currentQuotationsState.products.slice();
            // Quick Edit Product from the sales product table
            if (data.quickEdit) {
                let qeProduct = await getObjectFromArrayOfObjects(plProducts, id, '_id');
                if (qeProduct.length > 0) {
                    data.code = qeProduct['0'].code;
                }
                foundProduct = plProducts.find(item => item._id === id);
            } else {
                foundProduct = plProducts.find(item => item.id === id);
            }
            if(foundProduct.quickEdit === true) quickEdit = true;
            if (data.isPerDiscount && (data.isPerDiscount === "on" || data.isPerDiscount === "true")) {
                data.isPerDiscount = "true";
                data.isDiscountAmount = "false";
            }
            if (data.isDiscountAmount && (data.isDiscountAmount === "on" || data.isDiscountAmount === "true")) {
                data.isPerDiscount = "false";
                data.isDiscountAmount = "true";
            }
            if (data.name && data.name === '') {
                toast.error("Name is mandatory field.");
            } else if (data.code && data.code === '') {
                toast.error("Code is mandatory field.");
            } else {
                if (foundProduct) {
                    let papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(foundProduct.code)}`;
                    if (data.code && data.code !== '') {
                        papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(data.code)}`;
                    } else if (data.name && data.name !== '') {
                        papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-name/${encodeURIComponent(data.name)}`;
                    }
                    let loadingProduct = true;
                    if (loadingProduct) {
                        // Get product data from api.
                        await axios.get(papiUrl ,{params: company})
                            .then(res => {
                                if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                                    productData = res.data.data['0'];
                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    }
                    if(data.name || data.code) {
                        quickEdit = false;
                    }
                    if (data.unitPrice) {
                        productData.price = data.unitPrice;
                    } else if (foundProduct.unitPrice) {
                        productData.price = foundProduct.unitPrice;
                    }
                    // Field auto population on change product
                    if (((data.code && data.code !== '') || (data.name && data.name !== ''))) {
                        // Get Current Product Details with the API if product and client are selected.
                        if (currentQuotationsState.client && currentQuotationsState.client !== '') {
                            await axios.post(`${process.env.REACT_APP_API_URL2}/category/get-product-code-by-price`, { _id: productData._id, client: currentQuotationsState.client, company: company.id })
                                .then((res) => {
                                    if (res.data.status === "200") {
                                        let plProductData = res.data.data;
                                        data.vatIncluded = plProductData.vatIncluded; // Vat Type from price table
                                        productData.vatIncluded = plProductData.vatIncluded;
                                        data.discount = plProductData?.discount;
                                        data.isPerDiscount = plProductData?.isPerDiscount;
                                        data.isDiscountAmount = plProductData?.isDiscountAmount;
                                        data.name = plProductData?.name;
                                        data.code = plProductData?.code;
                                        data.mu = plProductData?.measurementUnit;
                                        data.muLabel = getLabelByValue(measurementUnitOptions, plProductData?.measurementUnit.toString(), 'value');
                                        if(!quickEdit) data.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                                        if(!quickEdit) data.vatPercentage = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                                        if(!quickEdit) data.vatReason = clientVatReason !== "" ? clientVatReason : plProductData?.vatReason;
                                        data.unitPrice = filterNaNValue(plProductData.productPrice);
                                        productData.price = filterNaNValue(plProductData.productPrice);
                                        productData.unitPrice = filterNaNValue(plProductData.productPrice);
                                    }
                                }).catch((err) => {
                                    console.log(err);
                                })
                        }
                        data.withHoldTax = productData.withholdTax;
                        data.otherTax = productData.otherTaxes;
                        data.stamp = productData.stamp;
                        data.fee = productData.fee;
                    }
                    if (productData?.vatIncluded === "true" && (data.name || data.code)) {
                        const price = parseFloat(productData.price);
                        const vat = isNaN(productData.vat) ? 0 : parseFloat(productData.vat);
                        if (vat > 0) {
                            data.unitPrice = Number(Number(price/(1 + vat/100)).toFixed(2));
                        } else {
                            data.unitPrice = parseNumber(productData.price);
                        }
                    } else {
                        data.unitPrice = parseNumber(productData.price);
                    }
                    // Updated selected product with updated field data.
                    foundProduct = { ...foundProduct, ...data }
                    if (currentQuotationsState.enablePeppol === "active") {
                        if (productData.cpvCode) {
                            foundProduct.cpvCode = productData.cpvCode;
                        } else {
                            foundProduct.cpvCode = undefined;
                        }
                    }
                    if (currentQuotationsState.fuelInvoice === "active") {
                        foundProduct.fuelCode = productData.fuelCode;
                    }
                    if (productData?.invoiceDetailType) {
                        foundProduct.invoiceDetailType = productData.invoiceDetailType;
                    } else {
                        foundProduct.invoiceDetailType = undefined;
                    }
                    if (productData?.specialOption) {
                        foundProduct.specialOption = productData.specialOption;
                    } else {
                        foundProduct.specialOption = undefined;
                    }
                    if (productData?.notVAT195) {
                        foundProduct.notVAT195 = productData.notVAT195;
                    } else {
                        foundProduct.notVAT195 = undefined;
                    }
                    if (!quickEdit) {
                        if (productData?.showAlternativeNameOnPrint === "true") {
                            foundProduct.showAlternativeNameOnPrint = "true";
                            foundProduct.alternativeName = productData.alternateName;
                        } else {
                            foundProduct.showAlternativeNameOnPrint = undefined;
                            foundProduct.alternativeName = undefined;
                        }
                    }
                    if (productData?.showAlternativeCodeOnPrint === "true") {
                        foundProduct.showAlternativeCodeOnPrint = "true";
                        foundProduct.alternativeCode = productData.alternateCode;
                    } else {
                        foundProduct.showAlternativeCodeOnPrint = undefined;
                        foundProduct.alternativeCode = undefined;
                    }
                    let discountType = 'euro';
                    if (foundProduct.isPerDiscount === 'true') {
                        discountType = 'per'
                    }
                    // Note: For inclusive vat the value is reducing by the vat percentage.
                    if (data.discount && data.discount !== '') { // on discount field change
                        foundProduct.discount = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct.vatIncluded, discountType);
                    }
                    // Re Calculate Unit price if net value changed
                    if (data.netValue && data.netValue !== '' && foundProduct.isTaxLine !== "true") {
                        // If user enters value here, you calculate "Unit Price" automatically (based on previous axiom: "Net Value" has to equal: "Quantity" times "Unit Price" minus "Discount")
                        foundProduct.unitPrice = getUnitPrice(data.netValue, foundProduct.quantity, foundProduct.discount, discountType);
                    } else {
                        if(foundProduct.isTaxLine === "true"){
                            foundProduct.netValue = 0;
                        } else {
                            foundProduct.netValue = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
                        }
                    }
                    foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
                    foundProduct.otherTaxEuro   = getProductOtherTax(foundProduct, SETTINGS);
                    foundProduct.feeEuro   = getProductFee(foundProduct, SETTINGS);
                    foundProduct.stampEuro   = getProductStamp(foundProduct, SETTINGS);
                    if (!isEmpty(productData?.deductionsEuro) && parseFloat(productData?.deductionsEuro) > 0) {
                        foundProduct.deductionsEuro = Number(parseFloat(productData?.deductionsEuro).toFixed(2));
                    }
                    if(foundProduct.isTaxLine === "true"){
                        foundProduct.taxes = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
                    } else {
                        foundProduct.taxes = getTaxes(foundProduct, SETTINGS);
                    }
                    // Re Calculate Unit price and net value if total value changed
                    let userTotalValInput = 0; // For recalculating vat +-
                    if (data.totalValue && data.totalValue !== '') {
                        if(foundProduct.isTaxLine === "true"){
                            foundProduct.taxes = getNetValueByTotalValue(data.totalValue, foundProduct.vatPercentage, foundProduct.taxes);
                            foundProduct.unitPrice = getUnitPrice(foundProduct.taxes, foundProduct.quantity, foundProduct.discount, discountType);
                            foundProduct.netValue = 0;
                        } else {
                            // If user enters value here, you calculate "Unit Price" and "Net Value" automatically (based on axioms: "Net Value" has to equal: "Quantity" times "Unit Price" minus "Discount" and "Total Value" equals: "VAT %" times "Net Value" plus "Net Value")
                            foundProduct.netValue = getNetValueByTotalValue(data.totalValue, foundProduct.vatPercentage, foundProduct.taxes);
                            foundProduct.unitPrice = getUnitPrice(foundProduct.netValue, foundProduct.quantity, foundProduct.discount, discountType);
                        }
                        userTotalValInput = data.totalValue;
                        //foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                    } else {
                        foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                    }
                    if(foundProduct.isTaxLine === "true"){
                        foundProduct.vat = getVatValue(foundProduct.taxes, foundProduct.vatPercentage);
                    } else {
                        if (foundProduct._id !== productData._id) {
                            foundProduct.code = productData.code;
                            foundProduct.name = productData.name;
                            foundProduct.unitPrice = isNaN(Number(productData.price)) ? 0 : productData.price;
                            foundProduct.measurementUnit = productData.measurementUnit;
                            foundProduct.netValue = (Number(foundProduct.quantity) * Number(foundProduct.unitPrice)).toFixed(2);
                            foundProduct.vatPercentage = !isNaN(productData.vat) ? productData.vat : 0;
                            foundProduct.totalValue = productData.vatIncluded === "true" ? getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes, foundProduct.vat) : getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                        }
                        foundProduct.vat = getVatValue(foundProduct.netValue, foundProduct.vatPercentage, userTotalValInput);
                    }
                    if(productData?.isTaxLine === "true"){
                        if(!quickEdit) foundProduct.vatPercentage  = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                        if(!quickEdit) {
                            if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(foundProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
                            } else if (clientVatCategory === "Zero VAT") {
                                foundProduct.vatId = "7";
                            } else {
                                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                            }
                        }
                        if(!quickEdit) foundProduct.vatReason      = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
                        foundProduct.discount       = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct.vatType, discountType);
                        foundProduct.netValue       = 0;
                        foundProduct.withHoldTax    = productData.withholdTax;
                        foundProduct.otherTax       = productData.otherTaxes;
                        foundProduct.fee           = productData.fee;
                        foundProduct.stamp           = productData.stamp;
                        foundProduct._id            = productData._id;
                        foundProduct.isTaxLine      = productData.isTaxLine;
                        foundProduct.classificationCategory = '';
                        foundProduct.classificationType = '';
                        foundProduct.vatExpenseType = '';
                        foundProduct.isTaxLineWithoutVat      = productData.isTaxLineWithoutVat;
                        foundProduct.taxes          = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
                        foundProduct.otherTaxEuro   = getProductOtherTax(foundProduct, SETTINGS);
                        foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
                        foundProduct.feeEuro        = getProductFee(foundProduct, SETTINGS);
                        foundProduct.stampEuro      = getProductStamp(foundProduct, SETTINGS);
                        foundProduct.vat            = getVatValue(foundProduct.taxes, foundProduct.vatPercentage);
                        foundProduct.totalValue     = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                    } else {
                        if(!quickEdit) foundProduct.vatPercentage = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                        if(!quickEdit) {
                            if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(foundProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
                            } else if (clientVatCategory === "Zero VAT") {
                                foundProduct.vatId = "7";
                            } else {
                                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                            }
                        }
                        if(!quickEdit) foundProduct.vatReason = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
                        foundProduct.discount = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct.vatIncluded, discountType);
                        foundProduct.withHoldTax = productData.withholdTax;
                        foundProduct.otherTax = productData.otherTaxes;
                        foundProduct.fee = productData.fee;
                        foundProduct.stamp = productData.stamp;
                        foundProduct._id = productData._id;
                        foundProduct.classificationCategory = '';
                        foundProduct.classificationType = '';
                        foundProduct.vatExpenseType = '';
                        foundProduct.taxes = getTaxes(foundProduct, SETTINGS);
                        foundProduct.otherTaxEuro = getProductOtherTax(foundProduct, SETTINGS);
                        foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
                        foundProduct.feeEuro = getProductFee(foundProduct, SETTINGS);
                        foundProduct.stampEuro        = getProductStamp(foundProduct, SETTINGS);
                        if (isEmpty(data.vat)) foundProduct.vat = getVatValue(foundProduct.netValue, foundProduct.vatPercentage, userTotalValInput);
                        foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes, foundProduct.vat);
                    }
                    const updatedPmProducts = { ...plProducts[foundProduct.no - 1], ...foundProduct }
                    let productQuotationsTaxes;

                    plProducts[foundProduct.no - 1] = updatedPmProducts;
                    let productTotals = getSalesTotals(plProducts, SETTINGS);
                    productQuotationsTaxes = getSalesTaxesData(plProducts, currentQuotationsState.extraData, productTotals, SETTINGS);
                    let totalTaxes = 0;
                    let withHoldTaxes = 0;
                    let deductions = 0;
                    if(productQuotationsTaxes.length > 0 && productQuotationsTaxes[0].vatPercentage === "Invoice Level Tax"){
                        totalTaxes = parseFloat( (Number(productQuotationsTaxes[0].otherTaxes) + Number(productQuotationsTaxes[0].fees) + Number(productQuotationsTaxes[0].stamp)).toString());
                        withHoldTaxes = parseFloat(productQuotationsTaxes[0].withholdTaxes).toFixed(2);
                        deductions = parseFloat(productQuotationsTaxes[0].deductions).toFixed(2);
                    }
                    if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
                        productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
                        productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
                    }
                    if(currentState) {
                        setRefreshPage(refreshPage + 1); // Refresh page
                        setProductTableSpinner('false');
                        return { ...currentQuotationsState, products: plProducts, salesTaxes: productQuotationsTaxes, ...productTotals };
                    } else {
                        dispatch(setNewQuotations({ ...currentQuotationsState, products: plProducts, salesTaxes: productQuotationsTaxes, ...productTotals })); // update data
                    }
                    setRefreshPage(refreshPage + 1); // Refresh page
                    setProductTableSpinner('false');
                }
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!ACTIVITY.saveQuotations) dispatch(setSaveQuotations(true));

            let cloneProducts = structuredClone(SALES.newQuotations.products);
            cloneProducts.splice(rowIndex, 1);
            cloneProducts.forEach((prod, idx) => {
                prod.no = idx + 1;
                prod.id = String(idx + 1);
            })
            dispatch(setNewQuotations({...SALES.newQuotations, products: cloneProducts}));
            setUpdateSaleAmounts(true);
        }
    }

    const selectedDocumentType = getDefaultOptionByValue(documentTypesOptions, SALES.newQuotations.documentType, 'value', 'label', 'value');

    let tableWrClasses = "product-form sales-products-list position-relative";

    if (SALES.newQuotations.client !== '') {
        tableWrClasses += " normalIndex";
    }

    const [incrKey, setIncrKey] = useState(0);
    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [SALES.newQuotations.products, quotationsProductList])

    const [incrKey2, setIncrKey2] = useState(0);
    useEffect(() => {
        setIncrKey2(incrKey2 + 1);
    }, [SALES.newQuotations.products, quotationsProductList, SALES.newQuotations.extraData])

    const newQuotationsTab = [
        {
            tabName: t('SalesNew.productTable.title'),
            tabData: (
                <React.Fragment>
                    <Row className={tableWrClasses}>
                        <Col md={12}>
                            {(SALES.newQuotations.client === '' && SALES.newQuotations.newClient === '') && <div className="overlay_w">{t('SalesNew.message2')}</div>}
                            {showProductTableSpinner && showProductTableSpinner === 'true' && <div className="overlay_w"> <div className="spinner-border" role="status"> <span className="sr-only">{t("SalesNew.loading")}</span> </div> </div>}
                            {SALES.newQuotations?.products && SALES.newQuotations?.products?.length === 0 && <span className="text-danger">{t('SalesNew.messageProductList')}</span>}
                            <EditableTable
                                tableName="Quotations Products List"
                                key={"Quotations Products List" + incrKey}
                                actionButtons={{
                                    print: false,
                                    delete: true,
                                    export: false,
                                    edit: true,
                                }}
                                columns={clientProductsColumns}
                                data={SALES.newQuotations.products}
                                allowInsertRow={true}
                                onUpdate={quotationsProductListActions}
                                allowActions={true}
                                allowToggleColumns={false}
                                allowPrintResults={false}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className={"d-flex justify-content-end"}>
                            {SALES.newQuotations?.discountAsLine === true && (
                                <div className={"mt-1 mr-3 text-muted"}>(*) Η έκπτωση θα προβληθεί ως γραμμή παραστατικού με περιγραφή: {SALES.newQuotations?.discountAsLineText}</div>
                            )}
                            <Button size={"sm"} onClick={() => setShowDiscountModal(true)}>Εφαρμογή Έκπτωσης</Button>
                        </Col>
                    </Row>
                </React.Fragment>
            ),
        },
    ];

    // Data For Quick Edit Client Details on selection
    let quickEditClientData = {};
    if (SALES.newQuotations.clientType === 'Existing') {
        if (SALES.newQuotations.client && SALES.newQuotations.client !== "") {
            quickEditClientData.name = SALES.newQuotations.clientName;
            quickEditClientData.id = SALES.newQuotations.client;
            quickEditClientData.vatCategory = SALES.newQuotations.vatCategory;
            quickEditClientData.address = SALES.newQuotations.address;
            quickEditClientData.vatNumber = SALES.newQuotations.vat;
            quickEditClientData.doy = getLabelByValue(getDOYOptions(), Number(SALES.newQuotations.doy), 'value');
            quickEditClientData.city = SALES.newQuotations.city;
            quickEditClientData.amka = SALES.newQuotations?.amka;
            quickEditClientData.clientCategoryName = SALES.newQuotations?.clientCategoryName;
            quickEditClientData.clientCategory = SALES.newQuotations?.clientCategory;
            quickEditClientData.pc = SALES.newQuotations.pc;
            quickEditClientData.email = SALES.newQuotations.email;
            quickEditClientData.phone = SALES.newQuotations.phone;
        }
    }

    const quickEditClient = (e, type, data) => {
        let selectedClient = SALES.newQuotations.client;
        if (selectedClient) {
            let quickClientData = {};
            // Quick Edit Client Details Data
            quickClientData._id = SALES.newQuotations.client;
            quickClientData.company = company.id;
            quickClientData.name = data.name;
            quickClientData.vatCategory = data.vatCategory;
            quickClientData.vatNumber = data.vatNumber;
            quickClientData.address = data.address;
            quickClientData.city = data.city;
            quickClientData.amka = data?.amka;
            quickClientData.categoryName = data?.clientCategoryName;
            quickClientData.category = data?.clientCategory;
            quickClientData.email = data.email;
            quickClientData.phone = data.phone;

            if (((data.email !== '' || data.phone !== '') && data.clientCategoryName !== "Patient") || (data.clientCategoryName === "Patient" && !isEmpty(data?.amka) && data.name !== '' && data.vatCategory !== '')) {
                dispatch(putClient(quickClientData, requestData));
                // Repopulate the client data to sales after updating the client.
                let sClient = data;
                let repopulateClient = {};
                repopulateClient.clientCategoryName = sClient?.clientCategoryName;
                repopulateClient.clientCategory = sClient?.clientCategory;
                repopulateClient.clientName = sClient.name;
                repopulateClient.address = sClient.address;
                repopulateClient.vat = sClient.vatNumber;
                repopulateClient.vatCategory = sClient.vatCategory;
                repopulateClient.city = sClient.city;
                repopulateClient.amka = sClient?.amka;
                repopulateClient.email = sClient.email;
                repopulateClient.pc = sClient.postalCode;
                repopulateClient.phone = sClient.phone;

                let quotationsData = Object.assign({}, SALES);
                dispatch(setNewQuotations({ ...quotationsData.newQuotations, ...repopulateClient }));

            } else {
                toast.error('Name, Email or Phone and Vat Category required fields.');
            }
        }
    }

    const clearClient = () => {
        if(SALES.newQuotations.client !== ''){
            let newQuotationsData = {};
            let salesData = Object.assign({}, SALES);
            newQuotationsData.client = "";
            newQuotationsData.clientName = "";
            newQuotationsData.clientCode = "";
            newQuotationsData.address = "";
            newQuotationsData.vat = "";
            newQuotationsData.doy = "";
            newQuotationsData.city = "";
            newQuotationsData.amka = "";
            newQuotationsData.clientCategoryName = "";
            newQuotationsData.clientCategory = "";
            newQuotationsData.country = "";
            newQuotationsData.pc = "";
            newQuotationsData.email = "";
            newQuotationsData.phone = "";
            newQuotationsData.activity = "";
            newQuotationsData.vatCategory = "";
            setClientInstallationListData(CLIENTS_DATA.newQuotationsData.slice());
            newQuotationsData.clientInstallationType = "";
            newQuotationsData.clientInstallationId = "";
            // Set Client Vat Category used for product vat calculation
            dispatch(setNewQuotationClientCustomData({
                clientVatCategory: "Normal VAT",
                clientVatReason: "",
                clientCustomVat: 0,
            }))
            dispatch(setNewQuotations({ ...salesData.newQuotations, ...newQuotationsData }));
        }
    }

    let quotationsTaxesColumns = [
        {
            name: t('SalesNew.salesTaxesTables.vat%'),
            field: "vatPercentage",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.netValue'),
            field: "netValue",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.vat'),
            field: "vatEuro",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.withHoldTaxes'),
            field: "withholdTaxes",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.otherTaxes'),
            field: "otherTaxes",
            width: "10%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.fees'),
            field: "fees",
            width: "10%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.stampDuty'),
            field: "stamp",
            width: "10%",
            editable: false,
        },
        {
            name: "Κρατήσεις",
            field: "deductions",
            width: "10%",
            editable: false,
        }
    ];
    let totalTaxes = 0;
    let withHoldTaxes = 0;
    let deductions = 0;
    let productTotals = useMemo(() => getSalesTotals(SALES.newQuotations.products, SETTINGS), [SALES.newQuotations.products]);
    let salesTaxesData = useMemo(() => getSalesTaxesData(SALES.newQuotations.products, SALES.newQuotations.extraData || {}, productTotals, SETTINGS), [SALES.newQuotations.products, SALES.newQuotations.extraData, productTotals]);
    if(salesTaxesData.length > 0 && salesTaxesData[0].vatPercentage === "Invoice Level Tax"){
        totalTaxes = parseFloat( (Number(salesTaxesData[0].otherTaxes) + Number(salesTaxesData[0].fees) + Number(salesTaxesData[0].stamp)).toString());
        withHoldTaxes = parseFloat(salesTaxesData[0].withholdTaxes).toFixed(2);
        deductions = parseFloat(salesTaxesData[0].deductions).toFixed(2);
    }

    let totalQuantity = productTotals.totalQuantity;
    let totalBeforeDiscount = productTotals.totalBeforeDiscount;
    let totalDiscount = productTotals.totalDiscount;
    let totalNetValue = productTotals.totalNetValue;
    let totalAmount = productTotals.totalAmount;
    let totalVatAmount = productTotals.totalVatValue;

    withHoldTaxes = parseFloat(parseFloat(productTotals.withHoldTaxes) + parseFloat(withHoldTaxes));

    if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
        totalAmount = parseFloat(totalAmount) + parseFloat(totalTaxes);
    }
    totalTaxes += Number(productTotals.totalTaxesAmount);
    const selectDocumentInstallation = getDefaultOptionByValue(dtInstallationsOptions, SALES.newQuotations.installation, 'value', 'label', 'value');
    const selectPreNumber = getDefaultOptionByValue(preNumberGreekOptions, SALES.newQuotations.preNumber, 'value', 'label', 'value');

    useEffect(() => {
        if(updateSaleAmounts === true) {
            setUpdateSaleAmounts(false);

            let extraData = {};
            if(salesTaxesData.length > 0) {
                salesTaxesData.forEach((salesTax) => {
                    if(salesTax.vatPercentage === "Invoice Level Tax") {
                        extraData.witholdTaxEuro = salesTax.withholdTaxes;
                        extraData.otherTaxEuro = salesTax.otherTaxes;
                        extraData.feeEuro = salesTax.fees;
                        extraData.stampEuro = salesTax.stamp;
                    }
                })
            }

            dispatch(setNewQuotations({
                ...SALES.newQuotations,
                salesTaxes: salesTaxesData,
                extraData: {...SALES.newQuotations.extraData, ...extraData},
                withHoldTaxes: withHoldTaxes.toFixed(2),
                ...productTotals,
            }))
        }
    }, [updateSaleAmounts]);

    const discountObj = useSelector((state) => state.SALES.quotationDiscountObject);
    const discountTypeOptions = [
        {label: "Ποσοστιαία %", value: "percentage"},
        {label: "Ποσό €", value: "amount"}
    ]
    const handleOnDiscountChange = (e, type, name) => {
        if (type === "dropdown") {
            dispatch(setQuotationDiscountObject({...discountObj, [name] : e.value, amount: 0}));
        } else if (type === "input") {
            dispatch(setQuotationDiscountObject({...discountObj, [name] : e.target.value}));
        } else if (type === "cb") {
            dispatch(setQuotationDiscountObject({...discountObj, [name] : e.target.checked}));
        }
    }
    const handleSaveDiscount = () => {
        if (!+SALES.newQuotations.totalNetValue > 0) return toast.error("Παρακαλώ συμπληρώστε πρώτα τις τιμές.");
        if (isNaN(discountObj.amount)) return toast.error(`Το ${discountObj.discountType === "percentage" ? "ποσοστό" : "ποσό"} δεν είναι δεκτός αριθμός.`);
        if (discountObj.discountAsLine === true && isEmpty(discountObj.discountAsLineText)) return toast.error("Παρακαλώ συμπληρώστε την περιγραφή της έκπτωσης.");

        let toApplyAmount = 0;
        if (discountObj.discountType === "percentage") {
            toApplyAmount = +Number((discountObj.amount / 100) * +SALES.newQuotations.totalNetValue).toFixed(2);
        } else if (discountObj.discountType === "amount") {
            toApplyAmount = +Number(discountObj.amount * (+SALES.newQuotations.totalNetValue / (+SALES.newQuotations.totalNetValue + +SALES.newQuotations.totalVatValue))).toFixed(2);
        }
        let clonedProducts = structuredClone(SALES.newQuotations.products);
        for (let prod of clonedProducts) {
            if (prod?.isTaxLine !== "true") {
                const ratio = (+prod.unitPrice * +prod.quantity) / (+SALES.newQuotations.totalNetValue + +SALES.newQuotations.totalDiscount);
                const discountAmount = +Number(ratio * toApplyAmount).toFixed(2);
                prod.isPerDiscount = "false";
                prod.isDiscountAmount = "true";
                prod.discount = discountAmount;
                prod.netValue = getNetValue(prod.unitPrice, prod.quantity, prod.discount);
                prod.taxes = getTaxes(prod, SETTINGS);
                prod.otherTaxEuro = getProductOtherTax(prod, SETTINGS);
                prod.witholdTaxEuro = getProductWithholdTax(prod, SETTINGS);
                prod.feeEuro = getProductFee(prod, SETTINGS);
                prod.stampEuro = getProductStamp(prod, SETTINGS);
                prod.vat = getVatValue(prod.netValue, prod.vatPercentage);
                prod.totalValue = getTotalValue(prod.netValue, prod.vatPercentage, prod.taxes);
            }
        }

        let productTotals = getSalesTotals(clonedProducts, SETTINGS);
        let productQuotationsTaxes = getSalesTaxesData(clonedProducts, SALES.newQuotations.extraData || {}, productTotals, SETTINGS);
        let totalTaxes = 0;
        let withHoldTaxes = 0;
        let deductions = 0;

        if(productQuotationsTaxes.length > 0 && productQuotationsTaxes[0].vatPercentage === "Invoice Level Tax"){
            totalTaxes = parseFloat( (Number(productQuotationsTaxes[0].otherTaxes) + Number(productQuotationsTaxes[0].fees) + Number(productQuotationsTaxes[0].stamp)).toString());
            withHoldTaxes = parseFloat(productQuotationsTaxes[0].withholdTaxes).toFixed(2);
            deductions = parseFloat(productQuotationsTaxes[0].deductions).toFixed(2);
        }

        if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
            productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
            productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
        }

        let prepSaleObj = {
            ...SALES.newQuotations,
            products: clonedProducts,
            salesTaxes: productQuotationsTaxes, // Important: Save the calculated taxes to state
            ...productTotals
        }

        prepSaleObj.discountAsLine = discountObj.discountAsLine;
        prepSaleObj.discountAsLineText = discountObj.discountAsLineText;

        dispatch(setNewQuotations(prepSaleObj));
        setShowDiscountModal(false);
        toast.success("Η έκπτωση εφαρμόστηκε επιτυχώς", {autoClose: 2000});
    }

    const hookNewClientInSale = (newClientData) => {
        if (newClientData) {
            const clientBasicData = {
                clientName: newClientData.name,
                client: newClientData._id,
                clientCode: newClientData.systemCode,
                clientType: 'Existing',
                address: newClientData.address,
                vat: newClientData.vatNumber,
                doy: getDOYOptions().find((el) => String(el.value) === String(newClientData.DOY))?.label,
                city: newClientData.city,
                amka: newClientData?.amka,
                clientCategoryName: newClientData.categoryName,
                clientCategory: newClientData.category,
                pc: newClientData.postalCode,
                country: newClientData.country,
                clientInstallationId: "0",
                clientInstallationType: "1",
                email: newClientData.email,
                phone: newClientData.phone,
                activity: newClientData.activity
            }
            newClientData.installations.map(installation => {
                installation.type = getLabelByValue(getInstallationsTypes(), installation.type, 'value');
                return installation;
            })
            clientBasicData.clientInstallationType = newClientData.installations[0]?.type;
            clientBasicData.clientInstallationId = newClientData.installations[0]?.no;

            const salesData = SALES.newQuotations;
            const newQuotationsData = {...salesData, ...clientBasicData}

            dispatch(setNewQuotations(newQuotationsData)); // Set auto select the newly added client
        }
    }

    return (
        <div className="new-sales">
            <div className="client-form product-form position-relative">
                {disabledFields && <div className="overlay_w">{t('SalesNew.message')}</div>}
                <Row className="border-bottom mb-2">
                    <Col sm={12} md={4} className="showWithOverlay">
                        <Dropdown
                            label={t('SalesNew.DocumentType')}
                            key={selectedDocumentType.value}
                            defaultValue={selectedDocumentType}
                            required={true}
                            searchEnable={true}
                            name="documentType"
                            options={documentTypesOptions}
                            onChange={(e) => handleOnChange(e, 'dd', 'documentType')}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md="3">
                        <DateBox
                            classes="w-100 mb-2"
                            label={t('SalesNew.Date')}
                            name="date"
                            selected={
                                SALES.newQuotations.date && !isNaN(new Date(SALES.newQuotations.date).getTime())
                                    ? new Date(SALES.newQuotations.date)
                                    : new Date()
                            }
                            onChange={(e) => handleOnChange(e, 'dp', 'date')}
                        />
                    </Col>
                    <Col sm="12" md="1">
                        <HourPicker
                            label={t('SalesNew.time')}
                            selected={
                                SALES.newQuotations.time && moment(SALES.newQuotations.time, "HH:mm").isValid()
                                    ? moment(SALES.newQuotations.time, "HH:mm").toDate()
                                    : new Date()
                            }
                            onChange={(e) => handleOnChange(e, "tp", "time")}
                        />
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    <Col sm="12" md="4">
                        <Dropdown
                            className={"mb-0"}
                            label={t('SalesNew.installation')}
                            options={dtInstallationsOptions}
                            value={Object.keys(selectDocumentInstallation).length !== 0 ? selectDocumentInstallation : ''}
                            enabledValue={true}
                            searchEnable={true}
                            required={true}
                            name="installation"
                            onChange={(e) => handleOnChange(e, 'dd', 'installation')}
                            disabled={String(SALES.newQuotations?.corelatedDocument).length === 24}
                        />
                    </Col>
                    <Col sm="12" md="4">
                        <Dropdown
                            className={"mb-0"}
                            label={t('SalesNew.preNumber.preNumber')}
                            name="preNumber"
                            required={true}
                            key={Math.random()}
                            defaultValue={Object.keys(selectPreNumber).length !== 0 ? selectPreNumber : ''}
                            options={preNumberGreekOptions}
                            disabled={SALES.newQuotations.numberingMode === 'manual'}
                            onChange={(e) => handleOnChange(e, 'dd', 'preNumber')}
                        />
                        {ACTIVITY.saveSales  && SALES.newQuotations.preNumber === "" && <div className="text-danger">{t('SalesNew.preNumber.required')}</div>}
                    </Col>
                    <Col sm="12" md="4">
                        <Input
                            label={t('SalesNew.number.number')}
                            name="number"
                            required={true}
                            value={SALES.newQuotations.number}
                            placeholder={t('SalesNew.number.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                            disabled={SALES.newQuotations.numberingMode !== 'manual'}
                            autoComplete={"off"}
                        />
                        {ACTIVITY.saveSales  && SALES.newQuotations.number === "" && <div className="text-danger">{t('SalesNew.number.required')}</div>}
                    </Col>
                </Row>
                <Row>
                    {SALES.newQuotations.clientType === 'Existing' &&
                        <Col md="5" className={"mb-2"}>
                            <AdvancedCombobox
                                ACName="Quotations" // do not change name
                                className="w-200 ac-select-dropdown"
                                key={SALES.newQuotations.clientName}
                                defaultValue={SALES.newQuotations.clientName}
                                label={t('SalesNew.client.client')}
                                data={clientsListData}
                                onChangeSearch={onChangeSearch}
                                onChange={(e) => handleOnChange(e, 'acdd', 'client')}
                                excludeColumns={[]}
                                columns={clientDropdownColumns}
                                deleteEnable={false}
                                searchTableEnable={false}
                                showTableOptionOnSelect={true}
                                placeholder={t('SalesNew.client.placeholder')}
                                required={true}
                                showInsertAddButton={true}
                                hideSaveButton={true}
                                hideInsertNewRow={true}
                                inputFieldClasses="form-control"
                                disabled={false}
                            />
                            {ACTIVITY.saveQuotations && SALES.newQuotations.clientType === 'New' && SALES.newQuotations.newClient === "" && <div className="text-danger">{t('SalesNew.client.required')}</div>}
                            {ACTIVITY.saveQuotations && SALES.newQuotations.clientType === 'Existing' && SALES.newQuotations.client === "" && <div className="text-danger">{t('SalesNew.client.required')}</div>}
                        </Col>
                    }
                    {SALES.newQuotations.clientType === 'New' &&
                        <Col md="5" className={"mb-2"}>
                            <Input
                                className="w-100 newclient-field"
                                label={t('SalesNew.newRetailClient.newRetailClient')}
                                name="newClient"
                                autoComplete={"off"}
                                value={SALES.newQuotations.newClient}
                                placeholder={t('SalesNew.newRetailClient.placeholder')}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    }
                    {String(SALES.newQuotations?.corelatedDocument).length === 24 ? (
                        <Col md={1}></Col>
                    ) : (
                        <Col sm="1" md="1">
                            <div className="d-flex  mt-4">
                                <div className="quick-client-actions">
                                    {SALES.newQuotations.client !== '' && SALES.newQuotations.clientType === 'Existing' && <QuickEdit title="Edit selected client." columns={quickClientFields} data={quickEditClientData} hideCurrentValue={true} updateData={quickEditClient} />}
                                    {SALES.newQuotations.client !== '' && SALES.newQuotations.clientType === 'Existing' && <button className="btn quick-retail-clientbtn btn-default btn-sm" title="Clear Client Fields" onClick={clearClient}><i className="fas fa-xmark"></i></button>}
                                    {((SALES.newQuotations.client === '' && SALES.newQuotations.newClient === '') || SALES.newQuotations.clientType !== 'Existing') && <NewClientModal myDataType={SALES.newQuotations.myDataType} successCallback={(data) => hookNewClientInSale(data)} />}
                                </div>
                            </div>
                        </Col>
                    )}
                    {(SALES.newQuotations.clientType === 'Existing' && isEmpty(SALES.newQuotations.amka)) && (
                        <Col sm="12" md="2">
                            <div className="d-flex">
                                <AdvancedCombobox
                                    ACName="Client Installation" // do not change name
                                    className="w-100 ac-select-dropdown"
                                    defaultValue={SALES.newQuotations.clientInstallationType}
                                    label={t('SalesNew.clientInstallation.clientInstallation')}
                                    data={clientInstallationListData}
                                    onChangeSearch = {onChangeSearch}
                                    onChange={(e) => handleOnChange(e, 'acdd', 'clientInstallation')}
                                    excludeColumns={[]}
                                    columns={clientInstallationsDropdownColumns}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    placeholder={t('SalesNew.clientInstallation.placeholder')}
                                    required={true}
                                    showInsertAddButton={true}
                                    hideSaveButton={true}
                                    hideInsertNewRow={true}
                                    inputFieldClasses="form-control"
                                    disabled={String(SALES.newQuotations?.corelatedDocument).length === 24}
                                />
                            </div>
                        </Col>
                    )}
                    {(SALES.newQuotations.clientType === 'Existing' && !isEmpty(SALES.newQuotations.amka)) && (
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={"ΑΜΚΑ Ασθενή"}
                                name="amka"
                                autoComplete={"off"}
                                value={SALES.newQuotations.amka}
                                onChange={(e) => handleOnChange(e)}
                                disabled={true}
                                readonly
                            />
                        </Col>
                    )}
                    {SALES.newQuotations.clientType === 'Existing' && (
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={t('SalesNew.vat')}
                                name="vat"
                                autoComplete={"off"}
                                value={SALES.newQuotations.vat}
                                onChange={(e) => handleOnChange(e)}
                                disabled={true}
                                readonly
                            />
                        </Col>
                    )}
                    {SALES.newQuotations.clientType === 'Existing' && (
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={t('SalesNew.doy')}
                                name="doy"
                                autoComplete={"off"}
                                value={SALES.newQuotations.doy}
                                onChange={(e) => handleOnChange(e)}
                                disabled={true}
                                readonly
                            />
                        </Col>
                    )}
                    {/* Show if new client */}
                    {SALES.newQuotations.clientType === 'New' &&
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={t('SalesNew.email.email')}
                                name="email"
                                autoComplete={"off"}
                                required={SALES.newQuotations.clientType === 'New' && SALES.newQuotations.phone === ''}
                                value={SALES.newQuotations.email}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {ACTIVITY.saveSales && SALES.newQuotations.clientType === 'New' && SALES.newQuotations.email === "" && SALES.newQuotations.phone === "" && <div className="text-danger">{t('SalesNew.email.required')}</div>}
                        </Col>
                    }
                    {/* Show if new client */}
                    {SALES.newQuotations.clientType === 'New' &&
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={t('SalesNew.phone.phone')}
                                name="phone"
                                autoComplete={"off"}
                                required={SALES.newQuotations.clientType === 'New' && SALES.newQuotations.email === ''}
                                value={SALES.newQuotations.phone}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    }
                </Row>
                <Row>
                    <Col sm="12" md="2" className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t('SalesNew.city')}
                            name="city"
                            autoComplete={"off"}
                            value={SALES.newQuotations.city}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                    <Col sm="12" md="2" className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t('SalesNew.address')}
                            name="address"
                            autoComplete={"off"}
                            value={SALES.newQuotations.address}
                            disabled={String(SALES.newQuotations?.corelatedDocument).length === 24}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                    <Col sm="12" md="2" className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t("General.postalCode")}
                            name="pc"
                            autoComplete={"off"}
                            value={SALES.newQuotations.pc}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                    <Col md={6} className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t('General.activity')}
                            name="activity"
                            autoComplete={"off"}
                            value={SALES.newQuotations.activity}
                            onChange={(e) => handleOnChange(e)}
                            disabled={SALES.newQuotations.clientType !== 'New'}
                            readonly
                        />
                    </Col>
                </Row>
                <Row>
                    {SALES.newQuotations.salePurpose === "19" && (
                        <Col md={4}>
                            <Input
                                name={"salePurposeName"}
                                label={"Περιγραφή σκοπού διακίνησης"}
                                required={true}
                                autoComplete={"off"}
                                value={SALES.newQuotations.salePurposeName ? SALES.newQuotations.salePurposeName : ""}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    )}
                </Row>
                <Row>
                    <Col md="12" className="mb-2">
                        <ul className="react-tabs__tab-list tab-style tab-min component-subtabs">
                            {(() => {
                                const tabs = [...newQuotationsTab];

                                return tabs.map((tab, i) => (
                                    <li key={i} className="react-tabs__tab">
                                        <button type="button" onClick={() => setActiveTab(i)} className={`customNavBtn ${activeTab === i && "btnActive"}`}>
                                            <span className="textWrapper">{tab.tabName}</span>
                                        </button>
                                    </li>
                                ));
                            })()}
                        </ul>
                        {(() => {
                            const tabs = [...newQuotationsTab];

                            return <div className="innerTabPanel">{tabs[activeTab]?.tabData}</div>;
                        })()}
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md="8" style={{position: "inherit"}}>
                        <EditableTable
                            tableName={"Quotations New Taxes Calculations"}
                            className="sales-taxes-calculations"
                            allowActions={false}
                            key={incrKey2}
                            data={fixDocumentTaxesDisplay(SALES.newQuotations, "sales")}
                            columns={quotationsTaxesColumns}
                            actionButtons={{
                                print: false,
                                delete: false,
                                export: false,
                                edit: false,
                            }}
                        />
                    </Col>
                    <Col sm="12" md="4" className="d-flex justify-content-end">
                        <span className="mr-3 fw-bold">{t('SalesNew.totalsTable.title')}</span>
                        <table className="table table-bordered mb-2">
                            <tbody>
                            <tr><td className="fw-bold">{"Συνολική Ποσότητα"}</td><td>{totalQuantity}</td></tr>
                            <tr><td className="fw-bold">{"Σύνολο πριν από την Έκπτωση"}</td><td>{getGreekCurrencyFormat(totalBeforeDiscount)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολική Έκπτωση"}</td><td>{getGreekCurrencyFormat(totalDiscount)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολική Καθαρή Αξία"}</td><td>{getGreekCurrencyFormat(totalNetValue)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολικό Ποσό Φ.Π.Α."}</td><td>{getGreekCurrencyFormat(totalVatAmount)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολικό Ποσό Παρακρατούμενων Φόρων"}</td><td>{getGreekCurrencyFormat(withHoldTaxes)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολικό Ποσό Φόρων"}</td><td>{getGreekCurrencyFormat(totalTaxes)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολικό ποσό"}</td><td>{getGreekCurrencyFormat(totalAmount)}</td></tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <div style={{width: "100%"}}>
                            <div className="text-muted mb-2"><i>{"Σημειώσεις Προσφοράς"}</i></div>
                            <TextArea
                                rows="4"
                                placeholder={t('SalesNew.addNotes')}
                                name="notes"
                                value={SALES.newQuotations.notes}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            {/* Confirm Category Change */}
            <Modal backdrop={"static"} className="themeModal" show={showCategoryConfirmation} onHide={() => setshowCategoryConfirmation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('SalesNew.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t('SalesNew.warningMessage')}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setshowCategoryConfirmation(false)}>{t('SalesNew.no')}</Button>
                    <Button variant="primary" onClick={() => handleConfirmCategory()} >{t('SalesNew.yes')}</Button>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} show={showDiscountModal} onHide={() => setShowDiscountModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Εφαρμογή Έκπτωσης</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Dropdown
                                name={"discountType"}
                                label={"Τύπος Έκπτωσης"}
                                options={discountTypeOptions}
                                key={Math.random()}
                                defaultValue={discountTypeOptions.find((el) => el.value === discountObj.discountType)}
                                onChange={(e) => handleOnDiscountChange(e, "dropdown", "discountType")}
                            />
                        </Col>
                        <Col md={12}>
                            <Input
                                name={"amount"}
                                label={discountObj.discountType === "percentage" ? "Ποσοστό %" : "Ποσό €"}
                                value={discountObj.amount}
                                type={"number"}
                                autoComplete={"off"}
                                onChange={(e) => handleOnDiscountChange(e, "input", "amount")}
                            />
                        </Col>
                        <Col md={12}>
                            <BetterCheckBox
                                name={"discountAsLine"}
                                text={"Προβολή έκπτωσης ως γραμμή παραστατικού"}
                                checked={discountObj.discountAsLine}
                                className={"mt-3"}
                                onChange={(e) => handleOnDiscountChange(e, "cb", "discountAsLine")}
                            />
                        </Col>
                        {discountObj.discountAsLine === true && (
                            <Col md={12}>
                                <Input
                                    name={"discountAsLineText"}
                                    label={"Περιγραφή έκπτωσης"}
                                    required={true}
                                    value={discountObj.discountAsLineText}
                                    onChange={(e) => handleOnDiscountChange(e, "input", "discountAsLineText")}
                                />
                            </Col>
                        )}
                        <Col md={12} className={"mt-3"}>
                            <Alert variant={"secondary"}>Κατά την αποθήκευση οι προϋπάρχουσες εκπτώσεις θα αντικατασταθούν με τις καινούργιες.</Alert>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowDiscountModal(false)}>Κλείσιμο</Button>
                    <Button variant="primary" onClick={() => handleSaveDiscount()}>Εφαρμογή Έκπτωσης</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default QuotationsNew;
